import React, { ComponentProps } from 'react';

import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import styles from './Tooltip.module.css';

type TooltipProps = Omit<ComponentProps<typeof TooltipPrimitive.Content>, 'content' | 'children'> & {
  children?: React.ReactNode;
  content: React.ReactNode;
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  disableHoverableContent?: boolean;
  hideTooltip?: boolean;
};
export const Tooltip = ({
  children,
  content,
  open,
  defaultOpen,
  onOpenChange,
  disableHoverableContent,
  hideTooltip,
  ...props
}: TooltipProps) => {
  return (
    <TooltipPrimitive.Provider disableHoverableContent={disableHoverableContent} delayDuration={0}>
      <TooltipPrimitive.Root delayDuration={200} open={open} defaultOpen={defaultOpen} onOpenChange={onOpenChange}>
        <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Content
          className={hideTooltip ? styles.hideTooltipStyle : styles.tooltipContentStyle}
          side='bottom'
          {...props}
        >
          {content}
          <TooltipPrimitive.Arrow className={styles.tooltipArrowStyle} />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};
